let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("462n9")).then(() => parcelRequire('8f4JT'));